import { render } from "./StreamNavigationSidebar.vue?vue&type=template&id=78dca9ae&scoped=true"
import script from "./StreamNavigationSidebar.vue?vue&type=script&lang=js"
export * from "./StreamNavigationSidebar.vue?vue&type=script&lang=js"

import "./StreamNavigationSidebar.vue?vue&type=style&index=0&id=78dca9ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78dca9ae"

export default script